import React, { useState } from 'react';
import { Modal } from '@mui/material';

import CleanBanner from '@/components/corporate/CleanBanner';
import { certificates } from '../../components/data/Certificates';
import { plainPatents } from '../../components/data/PlainPatents';

const stats = [
  { num: '37+', label: '특허·SW·상표 등록' },
  { num: '9', label: '대표 등록 특허' },
  { num: '데이터·AI', label: '핵심 기술 분야' },
];

const Patent: React.FC = () => {
  const [visibleCount, setVisibleCount] = useState(12);
  const [zoomImage, setZoomImage] = useState<string | null>(null);

  return (
    <div className="cp">
      <CleanBanner eyebrow="PATENTS" title="특허 및 인증" desc="기술력으로 증명하는 프람트테크놀로지" />

      {/* 지표 */}
      <section className="cp-section cp-section--tight">
        <div className="cp__container">
          <div className="cp-stats">
            {stats.map((s) => (
              <div key={s.label} className="cp-stats__item">
                <div className="cp-stats__num">{s.num}</div>
                <div className="cp-stats__label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 대표 특허 */}
      <section className="cp-section cp-section--soft">
        <div className="cp__container">
          <div className="cp-head">
            <div className="cp-head__eyebrow">FEATURED</div>
            <h2 className="cp-head__title">대표 특허</h2>
          </div>
          <div className="cp-cert">
            {certificates.map((c, i) => (
              <div key={i} className="cp-cert__card" onClick={() => setZoomImage(c.image)}>
                <div className="cp-cert__imgwrap">
                  <img src={c.image} alt={c.title} />
                </div>
                <div className="cp-cert__body">
                  <div className="cp-cert__title">{c.title}</div>
                  <div className="cp-cert__meta">
                    {c.no} · {c.registeredAt}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 전체 등록 현황 */}
      <section className="cp-section">
        <div className="cp__container">
          <div className="cp-head">
            <div className="cp-head__eyebrow">REGISTRY</div>
            <h2 className="cp-head__title">특허 · SW · 상표 등록 현황</h2>
          </div>
          <div className="cp-registry">
            {plainPatents.slice(0, visibleCount).map((p, i) => (
              <div key={i} className="cp-registry__row">
                <div className="cp-registry__main">
                  <div className="cp-registry__title">{p.title}</div>
                  <div className="cp-registry__meta">
                    {p.no} · {p.author}
                  </div>
                </div>
                <div className="cp-registry__date">{p.registeredAt}</div>
              </div>
            ))}
          </div>
          {visibleCount < plainPatents.length && (
            <div className="cp-loadmore">
              <button type="button" onClick={() => setVisibleCount((c) => c + 12)}>
                더 보기 ({visibleCount}/{plainPatents.length})
              </button>
            </div>
          )}
        </div>
      </section>

      <Modal className="patent-modal" open={!!zoomImage} onClose={() => setZoomImage(null)}>
        <div className="modal-content">
          {zoomImage && <img src={zoomImage} alt="특허 인증" style={{ width: '320px', height: 'auto' }} />}
        </div>
      </Modal>
    </div>
  );
};

export default Patent;
